import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const QrThemeService = {
  get: async () => {
    const response = await apiService.get(`/${slug}/themes`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },

  create: async ({ data }) => {
    const response = await apiService.post(`/${slug}/themes`, data);
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/themes/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/themes/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(`/${slug}/themes/${id}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default QrThemeService;
